export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/pdf.worker.2d43cd97fc3aa8c9a6ae.worker.js");
}
